// extracted by mini-css-extract-plugin
export default {"code":"Code_code__FHA+O"};